import { ThunkAction } from 'redux-thunk';
import { StoreState } from '../types';

export type StoreThunk<T = void> = ThunkAction<T, StoreState, void>;

/**
 * Map of logout status codes to human readable messages
 */
export const LogoutStatusMessages = {
  session_expired: `Your secure session has expired due to inactivity.`,
  oauth_email_change_error: `Your email address was changed by your SSO
provider to one that is already in use. Please contact your IT administrator
for assistance.`,
  mfa_required_error: `Your account is required to configure Two-Factor
Authentication. You must complete this step to continue accessing your
account. Please log in to configure Two-Factor Authentication.`
};
